const agreementEN = ({date, signDate}) => `
*Insurance Online Application Agreement Statement*  

*Effective Date: ${date}*  

This *Insurance Online Application Agreement* ("Agreement") governs your use of the online insurance application services provided by Mutual Insurance Consultants Company ("Company," "We," "Us," or "Our") through our website https://mut-insurance.com/ ("Site"). By submitting an application for insurance coverage via this Site, you ("Applicant," "You," or "Your") agree to comply with and be bound by the terms and conditions outlined below.  

---

### 1. *Application Process*  
You acknowledge that:  
- All information provided in the online application is accurate, complete, and truthful to the best of your knowledge.  
- Incomplete, misleading, or fraudulent information may result in delays, rejection of your application, or cancellation of coverage.  
- Submission of an application does not guarantee approval or issuance of a policy.  

---

### 2. *Eligibility*  
- You must be at least 18 years of age (or the age of majority in your jurisdiction) to apply for insurance through this Site.  
- Applications for minors or dependents must be submitted by a legally authorized adult.  

---

### 3. *Electronic Consent*  
By using this Site, you consent to:  
- Receive all communications, disclosures, and policy documents electronically.  
- Transmit sensitive personal and financial information securely through our encrypted platform.  
- The use of electronic signatures as legally binding under applicable law (e.g., ESIGN Act, UETA).  

---

### 4. *Privacy & Data Security*  
- Your personal information will be collected, used, and protected in accordance with our [*Privacy Policy*](/TandC), which is incorporated into this Agreement.  
- We employ industry-standard security measures to safeguard your data; however, you acknowledge that no online transmission is 100% secure.  

---

### 5. *Disclaimers*  
- The Company reserves the right to verify application details through third-party sources (e.g., medical records, credit reports).  
- Technical errors, interruptions, or system failures during the application process are not the responsibility of the Company.  
- Coverage is not in effect until the application is approved, and full payment of the premium (if applicable) is received.  

---

### 6. *Amendments*  
We may update this Agreement periodically. Continued use of the Site after changes constitutes acceptance of the revised terms.  

---

### 7. *Governing Law*  
This Agreement is governed by the laws of Hong Kong, and any disputes will be resolved in the courts of Hong Kong.  

---

*By checking the box below or clicking "Submit," you:*  
- Confirm that you have read, understood, and agree to this Agreement.  
- Authorize the Company to process your application and contact you regarding your submission. 

--- 

*Contact Information: *  
For questions about this Agreement or your application, contact us at:  
mutual@mutalins.com.hk / 2385-1896 | Flat A, 9/F, Wah Hing Commercial Centre, 383 Shanghai Street, Yau Ma Tei, Kowloon, Hong Kong.

*Date:* ${signDate}  
`;

export default agreementEN;